export default __webpack_public_path__ + "static/media/illustration-how_share.d38d83c5.png";